import { SuperAdminConstants } from '../../../_constants';

const initialState = { getMetricsListLoading: true, data: '', error: false };

export function getMetricsListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_METRICS_LIST:
            return {
                getMetricsListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_METRICS_LIST:
            return {
                getMetricsListLoading: false,
                data: action.getMetricsList,
                error: false
            };
        case SuperAdminConstants.GET_METRICS_LIST_ERROR:
            return {
                getMetricsListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignMetric/getMetricList.reducer.js